import {
  adminDeleteLocationOptions,
  adminSaveLocationOptions,
  getCitiesOptions,
  getDistrictsOptions,
  getProvincesOptions,
} from './location.options'
import type {
  UserGetCountiesRequest,
  UserGetDistrictsRequest,
  UserGetCitiesRequest,
  AdminSetLocationInput,
  AdminDeleteLocationParams,
} from '../api'
import { useMutation, useQuery } from '@tanstack/react-query'
import { getCountiesOptions } from './location.options'

export const useGetProvinces = () => {
  return useQuery(getProvincesOptions())
}

export const useGetCounties = (filter: UserGetCountiesRequest) => {
  return useQuery(getCountiesOptions(filter))
}

export const useGetCities = (filter: UserGetCitiesRequest) => {
  return useQuery(getCitiesOptions(filter))
}

export const useGetDistricts = (filter: UserGetDistrictsRequest) => {
  return useQuery(getDistrictsOptions(filter))
}

export const useAdminSaveLocation = (data: AdminSetLocationInput) => {
  return useMutation(adminSaveLocationOptions(data))
}

export const useAdminDeleteLocation = (data: AdminDeleteLocationParams) => {
  return useMutation(adminDeleteLocationOptions(data))
}
